module.exports = __webpack_public_path__ + "static/media/Mountain6M.44acbb25.gif";